import type { MutableRefObject, RefObject } from "react";
import { createContext, useContext } from "react";

export const ScrollGroupContext = createContext<null | ScrollGroupContextType>(
  null,
);

type ScrollGroupContextType = {
  registerItem: (item: ScrollGroupItem) => () => void;
  scrollGroupItemsRef: MutableRefObject<ScrollGroupItem[]>;
  currentManualScrollMetaRef: MutableRefObject<null | {
    target: { top?: number; left?: number };
  }>;
  onScrollItem?: (element: HTMLElement, event: Event) => void;
  onAddItem?: (element: HTMLElement) => void;
  onResizeItem?: (element: HTMLElement) => void;
};

export type ScrollGroupItem = { refObject: RefObject<HTMLElement | null> };

export function useScrollGroupContext() {
  const contextValue = useContext(ScrollGroupContext);
  if (!contextValue) {
    throw new Error("Please wrap this component in <ScrollGroup />");
  }
  return contextValue;
}
